
/* Judge.me Branding Remover - Padel Needs */
(function() {
  function removeJudgeMeBranding() {
    // Remove by class
    var selectors = [
      '.jdgm-branding',
      '.jdgm-branding-footer', 
      '.jdgm-rev-widg__branding',
      'a.jdgm-branding-footer',
      '[class*="jdgm-branding"]',
      '[class*="jdgm-brand"]',
      '.jdgm-rev-widg__footer',
      '.jdgm-prev-badge',
      '.jdgm-preview-badge',
      '.jdgm-widget.jdgm-preview-badge',
      '[data-widget-name="preview_badge"]',
      '.shopify-app-block:has(.jdgm-preview-badge)',
      'img.jdgm-verified-checkmark',
      'img[src*="judgeme-public-images"]',
      'img[src*="verified-checkmark"]'
    ];
    
    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) { 
        el.remove(); 
      });
    });
    
    // Remove by href containing judge.me
    var links = document.querySelectorAll('a[href*="judge.me"], a[href*="judgeme"]');
    links.forEach(function(link) {
      // Only remove if it looks like branding (small text, footer-like)
      var text = link.textContent.toLowerCase();
      if (text.indexOf('judge') !== -1 || text.indexOf('powered') !== -1 || text.indexOf('verified') !== -1) {
        // Keep verified buyer badges but remove branding links
        if (text.indexOf('verified') === -1) {
          link.remove();
        }
      }
    });
    
    // Remove any element containing "Powered by Judge.me" text
    var allElements = document.querySelectorAll('.jdgm-rev-widg *');
    allElements.forEach(function(el) {
      if (el.children.length === 0 && el.textContent) {
        var t = el.textContent.trim().toLowerCase();
        if (t.indexOf('powered by') !== -1 && t.indexOf('judge') !== -1) {
          el.closest('div, span, a, p') ? el.closest('div, span, a, p').remove() : el.remove();
        }
      }
    });
  }
  
  // Run immediately
  removeJudgeMeBranding();
  
  // Run after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeJudgeMeBranding);
  }
  
  // Run after window load (Judge.me loads async)
  window.addEventListener('load', function() {
    removeJudgeMeBranding();
    // Run again after a delay since Judge.me might load late
    setTimeout(removeJudgeMeBranding, 1000);
    setTimeout(removeJudgeMeBranding, 2000);
    setTimeout(removeJudgeMeBranding, 3000);
    setTimeout(removeJudgeMeBranding, 5000);
  });
  
  // MutationObserver to catch dynamically added branding
  var observer = new MutationObserver(function(mutations) {
    var shouldClean = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length > 0) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            var cl = node.className || '';
            var href = node.getAttribute ? (node.getAttribute('href') || '') : '';
            if (cl.toString().indexOf('jdgm-branding') !== -1 || 
                cl.toString().indexOf('jdgm-brand') !== -1 ||
                href.indexOf('judge.me') !== -1) {
              shouldClean = true;
            }
          }
        });
      }
    });
    if (shouldClean) {
      removeJudgeMeBranding();
    }
  });
  
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();
